export default __webpack_public_path__ + "static/media/ic_menu.ed2da86e.svg";